const s = (t, e) => {
  const o = t.__vccOpts || t;
  for (const [r, c] of e)
    o[r] = c;
  return o;
};
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/_virtual/_plugin-vue_export-helper.js
// module id = 20
// module chunks = 67